import { HubConnection } from '@microsoft/signalr';
import { createContext } from 'react';

interface ISignalRContext {
  connection: HubConnection | undefined;
  established: boolean;
  methods: string[];
  setMethods: (arg: string) => void;
}

export const SignalRContext = createContext<ISignalRContext>({
  connection: undefined,
  established: false,
  methods: [],
  setMethods: methodName => {},
});
